import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { IApplicationFiltersState } from '../reducers/filters.reducer';
import { EDataLoadingMode } from '../../../shared/constants/filter-data-loading-mode.config';
import { IPeriod } from '../../../shared/interfaces/time-periods.interface';

export const APPLICATION_FILTERS_ACTIONS = createActionGroup({
  source: 'Application Filters',
  events: {
    validated: props<{ data: Partial<IApplicationFiltersState> }>(),
    update: props<{ data: Partial<IApplicationFiltersState> }>(),
    startLoadingData: emptyProps(),
    stopLoadingData: emptyProps(),
    setLoadingMode: props<{ mode: EDataLoadingMode }>(),
    setPeriod: props<{ period: IPeriod }>(),
    setMonthVSMonth: props<{ firstMonth: string; secondMonth: string }>(),
    setScorecardIds: props<{ ids: number[] }>(),
  },
});

export const APPLICATION_FILTERS_SAVE_ACCOUNTS_AND_SITES_QUERIES = createActionGroup({
  source: 'Application Filters SAVE Queries',
  events: {
    save: emptyProps(),
    success: emptyProps(),
    error: emptyProps(),
  },
});

export const APPLICATION_FILTERS_GET_ACCOUNTS_AND_SITES_QUERIES = createActionGroup({
  source: 'Application Filters GET Queries',
  events: {
    get: props<{ data: { siteIdsHash: string; accountIdsHash: string } }>(),
    success: emptyProps(),
    error: emptyProps(),
  },
});
